import { useEffect } from 'react';

const DownloadApk = () => {
  useEffect(() => {
    // Create a link to the APK file in the public folder
    const link = document.createElement('a');
    link.href = '/adana-paints.apk'; // APK file in public/
    link.download = 'adana-paints.apk'; // This will prompt download with this name
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }, []);

  return (
    <div>
      <p>Downloading APK...</p>
    </div>
  );
};

export default DownloadApk;